import React from 'react';
import Button from 'react-bootstrap/Button';
import { getUniqueIndex } from 'components/transactionEditor/RequestMatchersList';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import XmlNamespace from 'components/transactionEditor/Wizards/XmlNamespace';
import { XmlNamespaceItem } from 'components/transactionEditor/BodyMatchersList';
import { Matcher } from '../../../types/rest/dslTypes';

export interface XmlNamespaceItemProps {
  id: string;
  xmlNamespaceList: XmlNamespaceItem[];
  onXmlNamespaceChange: (list: XmlNamespaceItem[]) => void;
  matcherType: Matcher;
  isReadOnly?: boolean;
}

const XmlNamespaceList = (props: XmlNamespaceItemProps) => {
  const { t } = useTranslation('transactions');

  const handleChange = (name: string, value: string, id: string) => {
    if (props.xmlNamespaceList) {
      const list = [...props.xmlNamespaceList];
      const index: number = list.findIndex(item => item.id === id);
      list[index][name] = value;
      props.onXmlNamespaceChange(list);
    }
  };

  const addNewNamespace = () => {
    const emptyItem = {
      id: 'new-xml-namespace-' + getUniqueIndex(props.xmlNamespaceList),
      prefix: '',
      uri: '',
    } as XmlNamespaceItem;
    const list = props.xmlNamespaceList ? props.xmlNamespaceList.concat(emptyItem) : [emptyItem];
    props.onXmlNamespaceChange(list);
  };

  const handleDelete = (id: string) => {
    const items = props.xmlNamespaceList.filter(bm => bm.id !== id);
    props.onXmlNamespaceChange(items);
  };

  const title =
    props.matcherType === Matcher.matches_xml
      ? t('editor.xmlNamespaceForXpathMatching')
      : t('editor.xmlNamespaceForCdataXpathMatching');

  if (props.xmlNamespaceList && props.xmlNamespaceList.length > 0) {
    const length = props.xmlNamespaceList.length;
    return (
      <div id="div-nspace-list">
        <label className={'mb-5 font-size-jb font-weight-semi-bold'}>{title}</label>
        <Row>
          <Col>
            {props.xmlNamespaceList.map((item: XmlNamespaceItem, index: number) => (
              <XmlNamespace
                isReadOnly={props.isReadOnly}
                xmlNamespaceItem={item}
                onAdd={addNewNamespace}
                onChange={handleChange}
                onDelete={() => handleDelete(item.id)}
                displayAdd={index === length - 1}
                id={item.id}
                key={item.id}
              />
            ))}
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div id={props.id}>
      <label className={'font-size-jb font-weight-semi-bold'}>{title}</label>
      <div id="qa-xml-namespace-div">
        <p>{t('editor.noXmlNamespacesDefined')}</p>
        <Button
          onClick={addNewNamespace}
          id="qa-btn-save-xml-namespace"
          className={'btn-secondary'}
          title={t('editor.addXmlNamespace')}
        >
          {t('editor.createXmlNamespaceList')}
        </Button>
      </div>
    </div>
  );
};

export default XmlNamespaceList;
